The URL of the `WebhookSubscription` that the events have been delivered to.
